import { HTMLContent } from "../Content"
import styled from "styled-components"

export const MyHTMLContent = styled(HTMLContent)`
  color: ${props => (props.color ? props.color : props.theme.colors.text)};
  a {
    color: ${props =>
      props.hrefColor ? props.hrefColor : props.theme.colors.link};
    text-decoration: none;
  }

  ul li {
    margin-bottom: 0.1rem;
    ul {
      list-style-type: none;
      li::before {
        content: "- ";
      }
  }

  text-align: ${props => props.detailAlign};
  font-size: 1.3rem;
  line-height: 2rem;
  font-weight: 500;
`
